import _parseInt from "@babel/runtime-corejs3/core-js-stable/parse-int";
function findCount(value) {
  return value ? _parseInt(value, 10) : 0;
}
function compareCountTotals(householdCount) {
  if (!householdCount) return;
  var optionalTotal = findCount(householdCount.adults) + findCount(householdCount.children);
  var total = findCount(householdCount.total);
  return optionalTotal > total ? '# of adults and children can not exceed total count!' : null;
}
export { compareCountTotals };
//# sourceMappingURL=compareCountTotals.js.map